module.exports = __webpack_public_path__ + "img/ClickForSound_13.5b3fc19d.png";